import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(App, appConfig)
  .then(() => hideSplashScreen())
  .catch((err) => console.error(err));

const hideSplashScreen = () => {
  const exitAnimationClass = 'animate-scale-out';
  const splashScreen = document.getElementById('upu-splash-screen');

  if (splashScreen) {
    splashScreen.classList.add(exitAnimationClass);
    splashScreen.addEventListener('animationend', () => splashScreen.remove());
  }
};
